import { createReducer, on } from '@ngrx/store';
import { CustomVendorReportingUtils } from '../custom-vendor-reporting-utils';
import {
  CustomVendorReportingOverviewList,
  CustomVendorReportingSearchFilters,
  VendorReportingDetailResponse,
  VendorReportingDetailResultsData,
  CustomRioDataEvaluationOverviewList,
} from '../custom-vendor-reporting.models';
import * as CustomVendorReportingActions from './custom-vendor-reporting.action';

export const customVendorReportingFeatureKey = 'customVendorReporting';

export const CUSTOM_VENDOR_REPORTING_OVERVIEW = 'customVendorReportingOverview';
export const CUSTOM_VENDOR_REPORTING_FILTERS = 'customVendorReportingFilters';
export const CUSTOM_VENDOR_REPORTING_DETAILS = 'customVendorReportingDetails';
export const CUSTOM_VENDOR_REPORTING_DETAILS_DELETE =
  'customVendorReportingDetailsDelete';
export const CUSTOM_VENDOR_REPORTING_DETAILS_UPDATE =
  'customVendorReportingDetailsUpdate';
  export const CUSTOM_RIO_DATA_EVALUATION_OVERVIEW = 'customRioDataEvaluationOverview';
  export const CUSTOM_DATA_EVALUATION_FILTERS = 'customVendorReportingDataEvaluationFilters';


export interface CustomVendorReportingState {
  [CUSTOM_VENDOR_REPORTING_OVERVIEW]: {
    vendorReportingOverview: CustomVendorReportingOverviewList;
    isLoading: boolean;
    error?: Error;
    showTransferred?: boolean;
  };
  [CUSTOM_VENDOR_REPORTING_FILTERS]: {
    searchFilters: CustomVendorReportingSearchFilters;
  };
  [CUSTOM_VENDOR_REPORTING_DETAILS]: {
    vendorReportingDetails: VendorReportingDetailResponse;
    isLoading: boolean;
    error?: Error;
  };
  [CUSTOM_VENDOR_REPORTING_DETAILS_DELETE]: {
    isRunning: boolean;
    success: boolean;
    error?: boolean;
  };
  [CUSTOM_VENDOR_REPORTING_DETAILS_UPDATE]: {
    isRunning: boolean;
    success: boolean;
    error?: boolean;
    messages?: VendorReportingDetailResultsData[];
  };
  [CUSTOM_RIO_DATA_EVALUATION_OVERVIEW]: {
    vendorReportingOverview: CustomRioDataEvaluationOverviewList;
    isLoading: boolean;
    error?: Error;
    showTransferred?: boolean;
  };
  [CUSTOM_DATA_EVALUATION_FILTERS]: {
    searchFilters: CustomVendorReportingSearchFilters;
  };
}

export const initialState: CustomVendorReportingState = {
  [CUSTOM_VENDOR_REPORTING_OVERVIEW]: {
    vendorReportingOverview: null,
    isLoading: false,
    error: null,
    showTransferred: false,
  },
  [CUSTOM_VENDOR_REPORTING_FILTERS]: {
    searchFilters: CustomVendorReportingUtils.initSearchFilters(),
  },
  [CUSTOM_VENDOR_REPORTING_DETAILS]: {
    vendorReportingDetails: null,
    isLoading: false,
    error: null,
  },
  [CUSTOM_VENDOR_REPORTING_DETAILS_UPDATE]: {
    isRunning: false,
    success: false,
    error: false,
    messages: null,
  },
  [CUSTOM_VENDOR_REPORTING_DETAILS_DELETE]: {
    isRunning: false,
    success: false,
    error: false,
  },
  [CUSTOM_RIO_DATA_EVALUATION_OVERVIEW]: {
    vendorReportingOverview: null,
    isLoading: false,
    error: null,
    showTransferred: false,
  },
  [CUSTOM_DATA_EVALUATION_FILTERS]: {
    searchFilters: CustomVendorReportingUtils.initDataEvaluationSearchFilters(),
  },
};

export const customVendorReportingReducer = createReducer(
  initialState,
  on(
    CustomVendorReportingActions.getVendorReportingOverview,
    (state, action) => ({
      ...state,
      [CUSTOM_VENDOR_REPORTING_OVERVIEW]: {
        vendorReportingOverview: null,
        isLoading: true,
        error: null,
      },
      [CUSTOM_VENDOR_REPORTING_FILTERS]: {
        searchFilters:
          action.searchFilters ??
          initialState[CUSTOM_VENDOR_REPORTING_FILTERS].searchFilters,
      },
    })
  ),
  on(
    CustomVendorReportingActions.getVendorReportingOverviewSuccess,
    (state, action) => ({
      ...state,
      [CUSTOM_VENDOR_REPORTING_OVERVIEW]: {
        vendorReportingOverview: action.vendorReportingOverview,
        isLoading: false,
        error: null,
      },
    })
  ),
  on(
    CustomVendorReportingActions.getVendorReportingOverviewFailure,
    (state, action) => ({
      ...state,
      [CUSTOM_VENDOR_REPORTING_OVERVIEW]: {
        vendorReportingOverview: null,
        isLoading: false,
        error: action.error,
      },
    })
  ),

  //******************************************************

  on(
    CustomVendorReportingActions.getRioDataEvaluationOverview,
    (state, action) => ({
      ...state,
      [CUSTOM_RIO_DATA_EVALUATION_OVERVIEW]: {
        vendorReportingOverview: null,
        isLoading: true,
        error: null,
      },
      [CUSTOM_DATA_EVALUATION_FILTERS]: {
        searchFilters:
          action.searchFilters ??
          initialState[CUSTOM_DATA_EVALUATION_FILTERS].searchFilters,
      },
    })
  ),
  on(
    CustomVendorReportingActions.getRioDataEvaluationOverviewSuccess,
    (state, action) => ({
      ...state,
      [CUSTOM_RIO_DATA_EVALUATION_OVERVIEW]: {
        vendorReportingOverview: action.vendorReportingOverview,
        isLoading: false,
        error: null,
      },
    })
  ),
  on(
    CustomVendorReportingActions.getRioDataEvaluationOverviewFailure,
    (state, action) => ({
      ...state,
      [CUSTOM_RIO_DATA_EVALUATION_OVERVIEW]: {
        vendorReportingOverview: null,
        isLoading: false,
        error: action.error,
      },
    })
  ),
  //******************************************************
  on(CustomVendorReportingActions.clearVendorReportingOverview, (state) => ({
    ...state,
    [CUSTOM_VENDOR_REPORTING_OVERVIEW]: {
      vendorReportingOverview: null,
      isLoading: false,
      error: null,
    },
  })),
  on(
    CustomVendorReportingActions.clearVendorReportingSearchFilters,
    (state) => ({
      ...state,
      [CUSTOM_VENDOR_REPORTING_FILTERS]: {
        searchFilters:
          initialState[CUSTOM_VENDOR_REPORTING_FILTERS].searchFilters,
      },
    })
  ),
  //******************************************************
  on(CustomVendorReportingActions.getVendorReportingDetails, (state) => ({
    ...state,
    [CUSTOM_VENDOR_REPORTING_DETAILS]: {
      vendorReportingDetails: null,
      isLoading: true,
      error: null,
    },
  })),
  on(
    CustomVendorReportingActions.getVendorReportingDetailsSuccess,
    (state, action) => ({
      ...state,
      [CUSTOM_VENDOR_REPORTING_DETAILS]: {
        vendorReportingDetails: action.vendorReportingDetails,
        isLoading: false,
        error: null,
      },
    })
  ),
  on(
    CustomVendorReportingActions.getVendorReportingDetailsFailure,
    (state, action) => ({
      ...state,
      [CUSTOM_VENDOR_REPORTING_DETAILS]: {
        vendorReportingDetails: null,
        isLoading: false,
        error: action.error,
      },
    })
  ),

    //******************************************************
    on(CustomVendorReportingActions.updateVendorReportingDetails, (state) => ({
      ...state,
      [CUSTOM_VENDOR_REPORTING_DETAILS_UPDATE]: {
        isRunning: true,
        success: false,
        error: false,
        messages: null,
      },
    })),
    on(
      CustomVendorReportingActions.updateVendorReportingDetailsSuccess,
      (state) => ({
        ...state,
        [CUSTOM_VENDOR_REPORTING_DETAILS_UPDATE]: {
          isRunning: false,
          success: true,
          error: false,
          messages: null,
        },
      })
    ),
    on(
      CustomVendorReportingActions.updateVendorReportingDetailsFailure,
      (state, action) => ({
        ...state,
        [CUSTOM_VENDOR_REPORTING_DETAILS_UPDATE]: {
          isRunning: false,
          success: false,
          error: true,
          messages: action.errorMessage,
        },
      })
    ),
    on(
      CustomVendorReportingActions.updateVendorReportingDetailsReset,
      (state) => ({
        ...state,
        [CUSTOM_VENDOR_REPORTING_DETAILS_UPDATE]: {
          isRunning: false,
          success: false,
          error: false,
          messages: null,
        },
      })
    ),
    
  //******************************************************
  on(CustomVendorReportingActions.deleteVendorReportingDetails, (state) => ({
    ...state,
    [CUSTOM_VENDOR_REPORTING_DETAILS_DELETE]: {
      isRunning: true,
      success: false,
      error: false,
    },
  })),
  on(
    CustomVendorReportingActions.deleteVendorReportingDetailsSuccess,
    (state) => ({
      ...state,
      [CUSTOM_VENDOR_REPORTING_DETAILS_DELETE]: {
        isRunning: false,
        success: true,
        error: false,
      },
    })
  ),
  on(
    CustomVendorReportingActions.deleteVendorReportingDetailsFailure,
    (state) => ({
      ...state,
      [CUSTOM_VENDOR_REPORTING_DETAILS_DELETE]: {
        isRunning: false,
        success: false,
        error: true,
      },
    })
  ),
  on(
    CustomVendorReportingActions.deleteVendorReportingDetailsReset,
    (state) => ({
      ...state,
      [CUSTOM_VENDOR_REPORTING_DETAILS_DELETE]: {
        isRunning: false,
        success: false,
        error: false,
      },
    })
  ),

);
